import Formatter from '../helpers/Formatter';

export function useFormatter()
{
    return new Formatter();
}